import { Paper, PaperProps } from '@mantine/core';

export type IPaperProps = PaperProps & { children: React.ReactElement };

export function ZorroPaper({ ...props }: IPaperProps) {
  return <Paper {...props} />;
}
